import $http from 'middleware/http';



const FILE_NAME = 'links.json';
const FORCE_ENABLED_ID = '__enabled__';
const STATES_TYPES = {
  ng: '0',
  ok: '1',
};



export default {
  namespaced: true,

  state: {
    loaded: false,
    links: {},
  },

  getters: {
    loaded: state => state.loaded,
    filepath: (state, getters, rootState, rootGetters) => rootGetters['path/$join']('conf', FILE_NAME),
    state: state => id => state.links[id],
    keys: state => Object.keys(state.links),
    enabled: (state, getters, rootState, rootGetters) => id => {
      return rootGetters['config/forceLinkEnabled'] || state.links[id] === STATES_TYPES.ok || id === FORCE_ENABLED_ID
    },
    disabled: (state, getters) => id => !getters['enabled'](id),
  },

  actions: {
    async load({ commit, getters, rootGetters }) {
      const res = rootGetters['config/forceLinkEnabled'] ? {data: null} : await $http.get(getters['filepath']);
      commit('setData', res.data);
    },
    setEnabled({ commit }, id) {
      commit('setState', {id, linkState: STATES_TYPES.ok});
    },
    setDisabled({ commit }, id) {
      commit('setState', {id, linkState: STATES_TYPES.ng});
    },
    allEnabled({ commit }) {
      commit('setAll', STATES_TYPES.ok)
    },
    allDisabled({ commit }) {
      commit('setAll', STATES_TYPES.ng)
    },
  },

  mutations: {
    setState(state, {id, linkState}) {
      state.links[id] = linkState;
    },
    setData(state, json) {
      if (json) {
        const links = {};
        for (let key in json) {
          links[key] = json[key].status;
        }
        state.links = links;
      }
      state.loaded = true;
    },
    setAll(state, val) {
      for (let id in state.links) {
        state.links[id] = val;
      }
    },
  },
}


// WEBPACK FOOTER //
// ./src/js/store/modules/links.js